import { Response, apiAbortController } from '@ui/src';
import {
  ApplicationScheme,
  ApplicationSettingsEnum,
} from '../../applications/types';
import api from '../../../../api/api';
import { ApplicationSchemeSettingsKeys, PSPDetails } from '../../types';

export const applicationShemesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEmployeesApplicationSchemes: build.query<
      Response<ApplicationScheme>,
      string
    >({
      query: (query: string) => ({
        url: `/v1/applications-schemes?all=true${query
          .replace('?', '&')
          .split('&')
          ?.filter((item) => !item.includes('take'))
          ?.join('&')}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getApplicationScheme: build.query<{ data: ApplicationScheme }, string>({
      query: (id: string) => ({
        url: `/v1/applications-schemes/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    editApplicationSchemeVisibility: build.mutation<
      { data: ApplicationScheme },
      {
        id: string;
        body: {
          visible: boolean;
        };
      }
    >({
      query: (data) => ({
        url: `/v1/applications-schemes/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    editApplicationSchemeActive: build.mutation<
      { data: ApplicationScheme },
      {
        id: string;
        body: {
          active: boolean;
        };
      }
    >({
      query: (data) => ({
        url: `/v1/applications-schemes/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    editApplicationSchemeSettings: build.mutation<
      { data: PSPDetails },
      {
        [key: string]: any;
        key: ApplicationSchemeSettingsKeys | ApplicationSettingsEnum;
      }
    >({
      query: (data) => ({
        url: `/v1/settings`,
        method: 'PUT',
        body: data,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetEmployeesApplicationSchemesQuery,
  useLazyGetApplicationSchemeQuery,
  useEditApplicationSchemeSettingsMutation,
  useEditApplicationSchemeVisibilityMutation,
  useEditApplicationSchemeActiveMutation,
} = applicationShemesApi;

export const {
  endpoints: {
    getEmployeesApplicationSchemes,
    editApplicationSchemeSettings,
    getApplicationScheme,
    editApplicationSchemeVisibility,
    editApplicationSchemeActive,
  },
} = applicationShemesApi;
